import type { IHttpClient } from '../api/client.js';

export interface EvaluationTenantEntityCount {
  type: string;
  count: number;
  ingestionPercent: number | null;
}

export interface OfficialEvaluationTenant {
  name: string;
  provisioningState: string;
  evalsetVersion: string;
  region: string;
  ring: string;
  userCount: number;
  entities: EvaluationTenantEntityCount[];
  expiresAt: string | null;
  retrievedAt: string;
}

export async function getOfficialEvaluationTenant(
  client: IHttpClient,
): Promise<OfficialEvaluationTenant> {
  const { data } = await client.get<OfficialEvaluationTenant>(
    'EvaluationTenants/official',
  );
  return data;
}
